module.exports = __webpack_public_path__ + "c410b9e55f0f2a46114e5b22309efa8b.MP3";